import React, { useEffect } from 'react';
import { observer, useLocalStore } from 'mobx-react';
import { PracticalSectionSubmissionPageState } from './states/PracticalSectionSubmissionPageState';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import { useNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { PracticalSectionSubmissionForm } from '../../components/organisms/exam_sections/PracticalSectionSubmissionForm';
import { ExamPracticalSectionHeaderContent } from '../../components/organisms/exam_sections/ExamPracticalSectionHeaderContent';
import { V3Routes } from '../../routes';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';
import { GrayPage } from '../../components/atoms/layout/gray_page/GrayPage';
import { GrayPageHeader } from '../../components/atoms/layout/gray_page/GrayPageHeader';
import { GrayPageBody } from '../../components/atoms/layout/gray_page/GrayPageBody';

type Props = {
  match: {
    params: {
      examPracticalSectionId: string;
    };
  };
};

export const PracticalSectionSubmissionPage = observer(
  ({
    match: {
      params: { examPracticalSectionId },
    },
  }: Props) => {
    useNavigation(NavigationSpecs.side());
    const { pageState } = useLocalStore(() => {
      return {
        pageState: new PracticalSectionSubmissionPageState(),
      };
    });
    useEffect(() => {
      pageState.init(Number(examPracticalSectionId));
    }, [examPracticalSectionId]);
    const {
      practicalSection: practicalSection,
      fieldStates,
      submit,
      submitState: { submitting },
    } = pageState;
    if (practicalSection.loading) {
      return <LoaderRow />;
    }
    if (practicalSection.isEmpty()) {
      return <NotFoundPage entityType="実技試験提出ページ" />;
    }
    const sec = practicalSection.getOrThrow();
    const breadCrumbItems = [{ text: sec.title, to: V3Routes.examPracticalSection(sec.id) }, { text: '実技試験提出' }];
    return (
      <GrayPage id="exam-practical-section-submission-page">
        <GrayPageHeader>
          <BreadCrumb items={breadCrumbItems} hasHome />
          <ExamPracticalSectionHeaderContent examPracticalSection={sec} showReviewer={false} />
        </GrayPageHeader>
        <GrayPageBody>
          <PracticalSectionSubmissionForm
            id="exam-practical-section-submission-form"
            fields={fieldStates}
            loading={submitting}
            onSubmit={submit}
          />
        </GrayPageBody>
      </GrayPage>
    );
  }
);
